export default __webpack_public_path__ + "static/media/outro-img.211db307.png";